var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-stage-container" }, [
      _c(
        "div",
        {
          staticClass: "stage-setting-container",
          attrs: { id: "stage-setting-container" }
        },
        [
          _c(
            "draggable",
            {
              attrs: { list: _vm.stages, options: { draggable: ".draggable" } },
              on: {
                change: function($event) {
                  _vm.onChange($event)
                }
              }
            },
            [
              _vm._l(_vm.stages, function(stage, indexStage) {
                return _c(
                  "div",
                  { key: indexStage, staticClass: "stage draggable" },
                  [
                    _c("div", { staticClass: "stage-content" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-10 ellipsis text-left" },
                          [_vm._v(_vm._s(stage.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-2 setting text-right",
                            on: {
                              click: function($event) {
                                _vm.setStageFormMode("update", stage)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-cog" })]
                        )
                      ])
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stage stage-add", attrs: { id: "stage-add" } },
                [
                  _c("div", { staticClass: "stage-content" }, [
                    _c(
                      "span",
                      {
                        staticClass: "setting",
                        attrs: { id: "stageAdd" },
                        on: {
                          click: function($event) {
                            _vm.setStageFormMode("create")
                          }
                        }
                      },
                      [_vm._v("\n              Add Stage\n            ")]
                    )
                  ])
                ]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-popover",
            {
              ref: "popoverStage",
              attrs: {
                target: "stageAdd",
                placement: "auto",
                container: "stage-add"
              }
            },
            [
              _c("h3", [_vm._v("\n          STAGE\n        ")]),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  class: { "error-input": _vm.$v.dataStagePopover.name.$error }
                },
                [
                  _c("label", [_vm._v("Stage Name")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: { placeholder: "Stage Name" },
                    model: {
                      value: _vm.$v.dataStagePopover.name.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.dataStagePopover.name, "$model", $$v)
                      },
                      expression: "$v.dataStagePopover.name.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  class: {
                    "error-input": _vm.$v.dataStagePopover.cardLimit.$error
                  }
                },
                [
                  _c("label", [_vm._v("Maximum Card")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: { type: "number", placeholder: "Maximum Card" },
                    model: {
                      value: _vm.$v.dataStagePopover.cardLimit.$model,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$v.dataStagePopover.cardLimit,
                          "$model",
                          $$v
                        )
                      },
                      expression: "$v.dataStagePopover.cardLimit.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.stageFormMode === "update"
                ? _c(
                    "b-form-group",
                    [
                      _c("label", [_vm._v("DISABLE BACKWARD")]),
                      _vm._v(" "),
                      _c("j-toggle", {
                        model: {
                          value:
                            _vm.$v.dataStagePopover.isDisableBackward.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.dataStagePopover.isDisableBackward,
                              "$model",
                              $$v
                            )
                          },
                          expression:
                            "$v.dataStagePopover.isDisableBackward.$model"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.stageFormMode === "update"
                ? _c(
                    "b-form-group",
                    [
                      _c("label", [_vm._v("ENABLE PRIVILEGE USER ACTION")]),
                      _vm._v(" "),
                      _c("j-toggle", {
                        model: {
                          value:
                            _vm.$v.dataStagePopover.isPrivilageUserAction
                              .$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.dataStagePopover.isPrivilageUserAction,
                              "$model",
                              $$v
                            )
                          },
                          expression:
                            "$v.dataStagePopover.isPrivilageUserAction.$model"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$v.dataStagePopover.isPrivilageUserAction.$model &&
              _vm.stageFormMode === "update"
                ? _c(
                    "div",
                    { attrs: { id: "stage-config" } },
                    [
                      _c("div", { staticClass: "btn-add-stage-privilege" }, [
                        _c(
                          "span",
                          {
                            staticClass: "font-weight-bold",
                            attrs: { id: "stagePrivilegeAdd" }
                          },
                          [
                            _c("i", { staticClass: "fa fa-plus" }),
                            _vm._v("\n              Add\n            ")
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-popover",
                        {
                          ref: "popoverAddStagePrivilege",
                          attrs: {
                            show: _vm.popoverLabelUpdateShow,
                            target: "stagePrivilegeAdd",
                            triggers: "click",
                            placement: "auto",
                            container: "stage-config"
                          },
                          on: {
                            "update:show": function($event) {
                              _vm.popoverLabelUpdateShow = $event
                            }
                          }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              "\n              Add Privilege\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input": _vm.$v.newStagePrivilege.$error
                              }
                            },
                            [
                              _c(
                                "label",
                                { attrs: { for: "stagePrivilege" } },
                                [_vm._v("New Privilege User")]
                              ),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  id: "stagePrivilege",
                                  options: _vm.listMemberOptions,
                                  placeholder: "Select",
                                  "value-format": "object"
                                },
                                model: {
                                  value: _vm.newStagePrivilege,
                                  callback: function($$v) {
                                    _vm.newStagePrivilege = $$v
                                  },
                                  expression: "newStagePrivilege"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn",
                              on: {
                                click: function($event) {
                                  _vm.popoverLabelUpdateShow = false
                                }
                              }
                            },
                            [_vm._v("\n              Close\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn blue",
                              on: { click: _vm.addStagePrivilege }
                            },
                            [_vm._v("\n              Add\n            ")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dataStagePopover.listMemberPrivilageUser.length > 0
                        ? _c(
                            "b-row",
                            { staticClass: "assignee-list-vertical m__t--10" },
                            _vm._l(
                              _vm.dataStagePopover.listMemberPrivilageUser,
                              function(member, indexMember) {
                                return _c(
                                  "div",
                                  {
                                    key: indexMember,
                                    staticClass:
                                      "col-12 m__b--5 assignee-detail"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "checkbox assignee-outer"
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "row m__b--0 assignee-inner",
                                            attrs: { for: member.id }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-3 pr-0" },
                                              [
                                                _vm.getUserPhoto(member) !==
                                                  "" &&
                                                member.photo_url !== "photo_url"
                                                  ? _c("img", {
                                                      staticClass:
                                                        "img-responsive card-assignee-photo-modal",
                                                      attrs: {
                                                        title: _vm.getUserEmail(
                                                          member
                                                        ),
                                                        src: _vm.getUserPhoto(
                                                          member
                                                        )
                                                      }
                                                    })
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "card-assignee-initial-modal",
                                                        attrs: {
                                                          title: _vm.getUserEmail(
                                                            member
                                                          )
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.getUserInitial(
                                                                member
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-7 pl-0" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "f--bold" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getUserName(member)
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getUserTitle(member)
                                                    )
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-2" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "assignee-remove",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.deleteStagePrivilege(
                                                          member
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-trash fa-2x"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }
                            )
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn",
                  on: {
                    click: function($event) {
                      _vm.closePopoverStage()
                    }
                  }
                },
                [_vm._v("\n          Cancel\n        ")]
              ),
              _vm._v(" "),
              _vm.stageFormMode === "update"
                ? _c(
                    "b-button",
                    {
                      staticClass: "btn red",
                      on: { click: _vm.actionDeleteStage }
                    },
                    [_vm._v("\n          Delete\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-button",
                { staticClass: "btn blue", on: { click: _vm.actionStage } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.stagePopoverAction) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75b11851", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b11851","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/board/tabs/jBoardStageTab.vue
// module id = null
// module chunks = 